import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Row, Breadcrumb, Icon } from 'antd';
import DefaultTemplate from '../../templates/DefaultTemplate';
import DoubleTemplate from '../../templates/DoubleTemplate';
import TripleTemplate from '../../templates/TripleTemplate';
import QuadrupleTemplate from '../../templates/QuadrupleTemplate';
import TwoThirdTemplate from '../../templates/TwoThirdTemplate';
import { fetchSinglePage, clearSinglePage } from '../../../actions/singlePage.actions';
import { fetchSingleTemplate, clearSingleTemplate } from '../../../actions/templates.actions';
import NotFound from '../NotFound';
import { isEmpty } from 'lodash';
import { pageUtils } from '../../../utils/common';
import Mark from "mark.js/src/lib/mark";

const Page = props => {
    const [goToIndex, setGoToIndex] = useState(false);
    const { index } = props;

    const [pageNotFound, setPageNotFound] = useState(false);

    const pathPrefix =
        '/' +
        props.location.pathname
            .split('/')
            .splice(1, 1)
            .toString();

    useEffect(() => {
        const pageReceived = !(Object.keys(props.page).length === 0 && props.page.constructor === Object);
        if (pageReceived) {
            if (props.page.found) {
                props.fetchSingleTemplate(props.page.template);
                setPageNotFound(false);
            } else {
                setPageNotFound(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.page]);

    /** When: index page changed **/
    useEffect(() => {
        if (goToIndex && index !== undefined) {
            props.history.push(pathPrefix === '/edit' || pathPrefix === '/view' ? pathPrefix + index : index);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index, goToIndex]);

    /** When: url-path changed **/
    useEffect(() => {
        let pathArr = props.location.pathname.split('/').filter(part => part !== '');

        if (pathPrefix === '/edit' || pathPrefix === '/view') {
            pathArr.shift();
        }

        if (pathArr.length === 0) {
            setGoToIndex(true);
        } else {
            props.fetchSinglePage(pathArr);
        }

        let callBack;
        let content;
        do{
            content = document.querySelector(".pageContent");
        }while(content === null);
        callBack = setTimeout(() => {
            let url_string  = window.location.href;
            let url = new URL(url_string);
            let e = url.searchParams.get("query");
            if(e !== null){
                let instance = new Mark(document.querySelector(".pageContent"));

                instance.unmark();
                instance.mark(e);
            }
        }, 2500);

        return function(){
            props.clearSinglePage();
            props.clearSingleTemplate();
            this && (clearTimeout(this));
        }.bind(callBack);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.pathname]);

    const createPageContent = () => {
        let template = props.template;
        const templateReceived = template && !(Object.keys(template).length === 0 && template.constructor === Object);

        if (templateReceived) {
            switch (template.id) {
                case 'Default':
                    return <DefaultTemplate editMode={false} />;
                case 'Double':
                    return <DoubleTemplate editMode={false} />;
                case 'Triple':
                    return <TripleTemplate editMode={false} />;
                case 'Quadruple':
                    return <QuadrupleTemplate editMode={false} />;
                case 'TwoThird':
                    return <TwoThirdTemplate editMode={false} />;
                default: /* do nothing */
            }
        }
        return '';
    };

    const createBreadcrumbItems = () => {
        if (!isEmpty(props.page) && props.page.found === true) {
            let breadcrumbItems = [];
            const pagesDict = pageUtils.objectifyPages(props.pages);
            let page = pagesDict[pageUtils.getRootFormPath(props.page.path, true)];

            if (index !== page.path) {
                //Add the index page
                breadcrumbItems.push(
                    <Breadcrumb.Item key="/">
                        <Link to={pathPrefix === '/edit' || pathPrefix === '/view' ? pathPrefix + index : index}>
                            <Icon type="home" />
                        </Link>
                    </Breadcrumb.Item>
                );
                //Add the root page
                breadcrumbItems.push(
                    <Breadcrumb.Item key={page.path}>
                        <Link to={pathPrefix === '/edit' || pathPrefix === '/view' ? pathPrefix + page.path : page.path}>{page.title}</Link>
                    </Breadcrumb.Item>
                );

                //Add the subpages
                const currentPageObjectPath = pageUtils.getObjectStructureFromPath(props.page.path);
                currentPageObjectPath
                    .split('.')
                    .filter(part => part !== '')
                    .forEach(property => {
                        page = page[property];
                        if (property !== 'subpages') {
                            breadcrumbItems.push(
                                <Breadcrumb.Item key={page.path}>
                                    <Link to={pathPrefix === '/edit' || pathPrefix === '/view' ? pathPrefix + page.path : page.path}>{page.title}</Link>
                                </Breadcrumb.Item>
                            );
                        }
                    });
            }
            return breadcrumbItems;
        }
    };

    if (pageNotFound) {
        return <NotFound />;
    } else {
        return (
            <div className="pageContent">
                <Row className="template-row default-pageTitle">
                    <Col span={24}>
                        <h1 className="ant-typography">{props.page.title}</h1>
                        {props.page.headerImage && props.page.headerImage !== "" ?
                            <img src={props.page.headerImage} alt={props.page.headerImageAlt}/> :
                            null
                        }
                    </Col>
                </Row>
                <Row className="template-row default-pageTitle">
                    <Col span={24}>
                        <Breadcrumb>{createBreadcrumbItems()}</Breadcrumb>
                    </Col>
                </Row>
                {createPageContent()}
            </div>
        );
    }
};

const mapStateToProps = state => ({
    i18n: state.i18n,
    page: state.page.page,
    pages: state.pages.pages,
    index: state.pages.index,
    template: state.templates.template
});
const mapDispatchToProps = {
    fetchSinglePage,
    fetchSingleTemplate,
    clearSinglePage,
    clearSingleTemplate
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Page);
